import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-moon-name-display',
  templateUrl: './moon-name-display.component.html',
  styleUrls: ['./moon-name-display.component.css']
})
export class MoonNameDisplayComponent implements OnInit {

  @Input() fullMoon: number | undefined; 
  @Input() fullMoon2: number | undefined; 
  @Input() newMoon: number | undefined; 
  @Input() newMoon2: number | undefined; 
  @Input() firstqmoon: number | undefined; 
  @Input() firstqmoon2: number | undefined; 
  @Input() lastqmoon: number | undefined; 
  @Input() lastqmoon2: number | undefined; 
  @Input() fullMoonName: number | undefined;
  @Input() fullMoonName2: number | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
